import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogClose,
} from "@/components/ui/dialog"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import { Button } from "@/components/ui/button"
import type { Course } from "@/modules/courses/entities/courses"
import type { target } from "@/modules/courses/constants/courses"
import { useState } from "react"
import useCoursesInfo from "@/modules/courses/hooks/use-courses-info"
import { useUpdateTargetObjective } from "../../queries/use-update-target-objective"

interface TargetObjectiveModalProps {
  open: boolean
  target: typeof target
  selectedCourse: Course
  setOpen: (open: boolean) => void
  onSave: (targetObjective: Course["targetObjective"]) => void
}

export default function TargetObjectiveModal({
  open,
  target,
  selectedCourse,
  setOpen,
  onSave,
}: TargetObjectiveModalProps) {
  const { getCourseColor } = useCoursesInfo()
  const [targetObjective, setTargetObjective] = useState(selectedCourse.targetObjective)
  const color = getCourseColor(selectedCourse.subjectId)
  const { mutateAsync: updateTargetObjective, isPending: isLoading } = useUpdateTargetObjective()

  const handleOnChange = (target: Course["targetObjective"]) => {
    setTargetObjective(target)
  }

  const handleOnSave = async (selected: Course["targetObjective"]) => {
    await updateTargetObjective({ courseId: selectedCourse.id, targetObjective: selected })
    onSave(selected)
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Editar objetivo</DialogTitle>
          <DialogClose />
        </DialogHeader>
        <DialogDescription>Definí qué calificación querés obtener.</DialogDescription>
        <div className="mt-4">
          <p className="mb-2 flex items-center gap-2 text-sm text-muted-foreground">
            <span className="flex h-2 w-2 rounded-sm" style={{ background: color }}></span>
            Materia {selectedCourse.name}
          </p>
          <div className="mb-4 flex items-center space-x-2">
            <span className="font-bold">Objetivo</span>
            <Select
              onValueChange={handleOnChange}
              value={targetObjective}
              defaultValue={targetObjective}
            >
              <SelectTrigger className="h-10 w-[180px]">
                <SelectValue placeholder="Selecciona" />
              </SelectTrigger>
              <SelectContent>
                {Object.keys(target).map((key) => {
                  const { description } = target[key as keyof typeof target]
                  return (
                    <SelectItem key={key} value={key}>
                      {description}
                    </SelectItem>
                  )
                })}
              </SelectContent>
            </Select>
          </div>
          <div className="flex w-full justify-end">
            <Button disabled={isLoading} onClick={() => handleOnSave(targetObjective)}>
              {isLoading ? "Guardando..." : "Guardar"}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
